<script lang="ts">
	import Loader from '$lib/components/Loader/Loader.svelte';
</script>

<div class="loadingContainer">
	<div class="loading">
		<span>
			<Loader loading={true} />
		</span>
	</div>
	<div class="contentContainer">
		<div class="blankStripe title" />
		<div class="description">
			<div class="blankStripe descriptionFirst" />
			<div class="blankStripe descriptionSecond" />
		</div>
	</div>
</div>

<style>
	.loadingContainer {
		padding: 0;
		border-radius: 3px;
		box-shadow: 0 20px 25px -5px rgb(0 0 0 / 10%), 0 8px 10px -6px rgb(0 0 0 / 10%);
	}

	.loading {
		display: flex;
		align-items: center;
		justify-content: center;
		min-block-size: 30rem;
		border-radius: 3px;
		background-color: #f0f3f4;
		border-block-end: none;
	}

	.loading > span {
		scale: 2.5;
	}

	/* Recolor spinner to blue  */
	:global(.loadingContainer > .loading > span div) {
		border-block-end-color: #0094eb !important;
	}

	.contentContainer {
		inline-size: 100%;
		padding: var(--gutterMedium);
	}

	.blankStripe {
		padding: var(--gutterSmall);
		background-color: #f0f3f4;
		color: transparent;
	}

	.title {
		inline-size: 80%;
	}

	.description {
		margin-block: var(--gutterMedium);
		margin-inline: 0;
	}

	.descriptionFirst {
		inline-size: 90%;
		padding: var(--gutterSmaller);
	}

	.descriptionSecond {
		inline-size: 60%;
		margin-block-start: var(--gutterSmall);
		padding: var(--gutterSmaller);
	}
</style>
